import { defineMessages } from 'react-intl'

export const medicationsSidePanelMessages = defineMessages({
  subtitle: {
    defaultMessage: 'Active medications',
    description: 'Collapsed subtitle for the medications side-panel section',
  },
  subtitleWithCount: {
    defaultMessage: 'Active medications ({count})',
    description: 'Expanded subtitle for the medications side-panel section, including the medication count',
  },
  moreMedications: {
    defaultMessage: '+ {count} more',
    description: 'Label showing the number of additional medications hidden in the collapsed side-panel section',
  },
  prescribedOn: {
    defaultMessage: 'Prescribed on {date}',
    description: 'Date on which a medication was prescribed',
  },
  quantityAndRefills: {
    defaultMessage: '{quantity} ({refillCount, plural, one {# refill} other {# refills}})',
    description: 'Medication quantity followed by the number of available refills',
  },
  directionsAccessibilityLabel: {
    defaultMessage: 'Medication directions for {medicationName}',
    description: 'Accessibility label for the tooltip that contains medication directions',
  },
})
